import React, { Component } from "react";
import "./Footer.css";

export default class Footer extends Component {
  render() {
    return (
      <footer className="site-footer">
        <div className="site-footer__contact">
          <div className="site-footer__inner">
            <h6 className="site-footer__heading">ติดต่อสอบถามเพิ่มเติมได้ที่</h6>
            <p>
              ภาคปกติ - ภาคกศ.บป.{" "}
              <a href="tel:055706547">(055) 706 547</a>
              {" | "}
              <a
                href="https://www.facebook.com/kpru.register"
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>
            </p>
            <p>
              ปริญญาโท - ปริญญาเอก{" "}
              <a href="tel:055706555">(055) 706 555 ต่อ 1780, 1671</a>
              {" | "}
              <a
                href="https://www.facebook.com/kprugrads/"
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>
            </p>
            <p>
              ประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู{" "}
              <a href="tel:055706555">(055) 706 555 ต่อ 2010</a>
              {" | "}
              <a
                href="https://www.facebook.com/edukpru/"
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>
            </p>
          </div>
        </div>

        <div className="site-footer__bottom">
          <div className="site-footer__inner site-footer__bottom-row">
            <p>
              <a href="https://www.kpru.ac.th" target="_blank" rel="noreferrer">
                มหาวิทยาลัยราชภัฏกำแพงเพชร
              </a>{" "}
              69 หมู่ 1 ต.นครชุม อ.เมือง จ.กำแพงเพชร 62000
            </p>
            <p>Kamphaeng Phet Rajabhat University</p>
          </div>
        </div>
      </footer>
    );
  }
}
